import React from 'react';
import { motion } from 'framer-motion';
import { FaBrain, FaCode, FaDatabase, FaCloud } from 'react-icons/fa';
import './About.css';

const highlights = [
  { icon: <FaBrain />, label: 'AI Agents', desc: 'LangGraph & LangChain' },
  { icon: <FaCode />, label: 'RAG Chatbots', desc: 'Retrieval-Augmented Gen' },
  { icon: <FaDatabase />, label: 'Deep Learning', desc: 'PyTorch & TensorFlow' },
  { icon: <FaCloud />, label: 'Deployment', desc: 'Docker & AWS' },
];

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <span className="section-label">{'// About Me'}</span>
          <h2 className="section-title">Who I Am</h2>
        </div>

        <motion.div
          className="about__content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="about__text">
            <p>
              I am an <strong>AI Engineer</strong> with experience in building intelligent AI agents,
              retrieval-augmented generation (RAG) based chatbots, and deep learning models. Skilled
              in designing scalable AI solutions, developing APIs for models, and deploying them
              using Docker.
            </p>
            <p>
              I am eager to contribute to innovative projects focused on AI agents, conversational
              intelligence, and end-to-end AI deployment. My approach combines strong theoretical
              foundations with practical engineering skills to deliver production-ready AI systems.
            </p>

            <div className="about__soft-skills">
              <h4>Soft Skills</h4>
              <div className="about__pills">
                {['Problem-solving', 'Time Management', 'Communication', 'Adaptable', 'Team Player', 'Presentation'].map(
                  (skill) => (
                    <span className="tag" key={skill}>{skill}</span>
                  )
                )}
              </div>
            </div>
          </div>

          <div className="about__highlights">
            {highlights.map((item, i) => (
              <motion.div
                className="about__card"
                key={item.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
              >
                <div className="about__card-icon">{item.icon}</div>
                <div>
                  <h4>{item.label}</h4>
                  <span>{item.desc}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
